import React from "react";
import { Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  setSearch,
  setSelectedUser,
} from "../../../../redux/slices/searchSlice";
import Api from "../../../../core/Api";

const Searchbox = ({ data }) => {
  const dispatch = useDispatch();
  const searchSlice = useSelector((state) => state.searchSlice);
  const onChange = (value, item) => {
    const fetchData = async () => {
      const resp = await Api.getAnimalOwnerByIdAsync(item.id);
      const ownerData = await Api.getAnimalOwnersAsync(item.id);
      dispatch(setSearch(resp.data.data));
      dispatch(setSelectedUser(ownerData.data.data[0]));
    };
    fetchData();
  };
  const Option = Select.Option;

  return (
    <Select
      className="w-full "
      showSearch
      placeholder="Hasta sahibini seçin veya arayın."
      onChange={onChange}
      filterOption={(input, option) =>
        (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
      }
    >
      {data.map((n) => {
        return (
          <Option key={n.idAccount} value={n.id} id={n.idAccount}>
            {n.name}
          </Option>
        );
      })}
    </Select>
  );
};

export default Searchbox;
